// extracted by mini-css-extract-plugin
export default {"bookingForm":"BookingForm_bookingForm__zfU+Q","formGroup":"BookingForm_formGroup__HotPe"};